<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0"><i class="fa fa-book-open"></i> Napló</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <panel title="Feszültségmentesítés adatai">
          <Loading
            v-if="
              isolation === false ||
              task === false ||
              isolation_statuses === false
            "
            title="Feszültségmentesítés betöltése"
          ></Loading>
          <div v-else>
            <table class="table table-hover">
              <tbody>
                <tr>
                  <th>Név</th>
                  <td>
                    {{ isolation.position.name }} [{{
                      isolation.position.position_id
                    }}]
                  </td>
                </tr>
                <tr>
                  <th>Létrehozva</th>
                  <td>
                    {{ isolation.created_at | moment("YYYY-MM-DD, HH:mm") }}
                  </td>
                </tr>
                <tr>
                  <th>Létrehozta</th>
                  <td>{{ task.owner_simple.name }}</td>
                </tr>
                <tr>
                  <th>Területvezető</th>
                  <td>{{ task.location_leader_simple.name }}</td>
                </tr>
                <tr>
                  <th>Kék lakat felvevő</th>
                  <td>
                    {{
                      task.ddc_user_simple ? task.ddc_user_simple.name : "nincs"
                    }}
                  </td>
                </tr>
                <tr>
                  <th>Operátor</th>
                  <td>{{ task.operator_simple.name }}</td>
                </tr>
                <tr>
                  <th>Elindítva</th>
                  <td>
                    <span class="badge bg-warning">{{ task.started_at }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Státusz</th>
                  <td>
                    <span>{{
                      isolation_statuses.find((is) => is.id == isolation.status)
                        .name
                    }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    isolation.status >= 6 && isolation.position.is_high_voltage
                  "
                >
                  <th>Munkajegy</th>
                  <td>
                    <a
                      class="btn btn-xs btn-success"
                      :href="back_url + '/document/pdf/ticket/' + isolation.id"
                      target="_blank"
                    >
                      <i class="fa fa-print"></i> Munkajegy nyomtatása
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </panel>
      </div>
      <div
        class="col-lg-6"
        v-if="isolation.position && isolation.position.is_high_voltage"
      >
        <panel title="Munkajegy napló">
          <Loading
            title="Munkajegy naplók betöltése"
            v-if="!print_logs"
          ></Loading>
          <NoRecords
            title="Nincsenek Munkajegy napló események"
            v-else-if="print_logs.length == 0"
          ></NoRecords>
          <vue-good-table
            v-else
            :columns="print_log_columns"
            :rows="print_logs"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
          </vue-good-table>
        </panel>
        <panel title="Távmondat napló">
          <Loading
            title="Távmodat naplók betöltése"
            v-if="!message_logs"
          ></Loading>
          <NoRecords
            title="Nincsenek Távmondat napló események"
            v-else-if="message_logs.length == 0"
          ></NoRecords>
          <vue-good-table
            v-else
            :columns="message_log_columns"
            :rows="message_logs"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
          </vue-good-table>
        </panel>
      </div>
      <div class="col-lg-6">
        <panel title="Feszültségmentesítés">
          <Loading
            title="Feszültségmentesítési naplók betöltése"
            v-if="!unplug_logs"
          ></Loading>
          <NoRecords
            title="Nincsenek Feszültségmentesítési napló események"
            v-else-if="unplug_logs.length == 0"
          ></NoRecords>
          <vue-good-table
            v-else
            :columns="unplug_log_columns"
            :rows="unplug_logs"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
          </vue-good-table>
        </panel>
      </div>
      <div class="col-lg-6">
        <panel title="Feszültség alá helyezés">
          <Loading
            title="Feszültség alá helyezési naplók betöltése"
            v-if="!reconnect_logs"
          ></Loading>
          <NoRecords
            title="Nincsenek Feszültség alá helyezési napló események"
            v-else-if="reconnect_logs.length == 0"
          ></NoRecords>
          <vue-good-table
            v-else
            :columns="reconnect_log_columns"
            :rows="reconnect_logs"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
          </vue-good-table>
        </panel>
      </div>
      <div class="col-lg-6">
        <panel title="Ideiglenes feszültség alá helyezés">
          <Loading
            title="Ideiglenes Feszültség alá helyezési naplók betöltése"
            v-if="!temporary_reconnect_logs"
          ></Loading>
          <NoRecords
            title="Nincsenek Ideiglenes Feszültség alá helyezési napló események"
            v-else-if="temporary_reconnect_logs.length == 0"
          ></NoRecords>
          <vue-good-table
            v-else
            :columns="temporary_reconnect_log_columns"
            :rows="temporary_reconnect_logs"
            :lineNumbers="true"
            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
            :pagination-options="{
              enabled: true,
              position: 'bottom',
              firstLabel: 'Első Lap',
              lastLabel: 'Utolsó Lap',
              nextLabel: 'következő',
              prevLabel: 'előző',
              rowsPerPageLabel: 'Sor oldalanként',
              ofLabel: '/',
              allLabel: 'Összes',
              infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            }"
          >
          </vue-good-table>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Task from "../../apis/Task";
import Isolation from "../../apis/Isolation";
import User from "../../apis/User";
import Partner from "../../apis/Partner";
import Workflow from "../../apis/Workflow";
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Log from "../../apis/Log";
export default {
  components: {
    Loading,
    NoRecords,
  },
  data() {
    return {
      isolation: false,
      task: false,
      partner_users: false,
      partner: false,
      workflow: false,
      message_logs: false,
      unplug_logs: false,
      reconnect_logs: false,
      print_logs: false,
      temporary_reconnect_logs: false,
      errors: [],
      back_url: false,
      print_log_columns: [
        {
          label: "Munkajegy száma",
          field: "isolation_id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a számok között",
          },
        },
        {
          label: "Berendezés",
          field: "position_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a berendezések között",
          },
        },
        {
          label: "Munka leírása",
          field: "description",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a leírások között",
          },
        },
        {
          label: "Kiszakaszolás",
          field: "started_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
        {
          label: "Beszakaszolás",
          field: "closed_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
      ],
      reconnect_log_columns: [
        {
          label: "Berendezés megnevezése",
          field: "position_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a berendezések között",
          },
        },
        {
          label: "Kezdeményező neve",
          field: "ddc_user_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Dátum",
          field: "created_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
        {
          label: "Sorszám",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a sorszámok között",
          },
        },
        {
          label: "Utasítást adó neve",
          field: "operator_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Utasítás",
          field: "event",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az utasítások között",
          },
        },
        {
          label: "Utasítást vevő neve",
          field: "electrician_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
      ],
      unplug_log_columns: [
        {
          label: "Berendezés megnevezése",
          field: "position_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a berendezések között",
          },
        },
        {
          label: "Kezdeményező neve",
          field: "ddc_user_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Dátum",
          field: "created_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
        {
          label: "Sorszám",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a sorszámok között",
          },
        },
        {
          label: "Utasítást adó neve",
          field: "operator_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Utasítás",
          field: "event",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az utasítások között",
          },
        },
        {
          label: "Utasítást vevő neve",
          field: "electrician_name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
      ],
      message_log_columns: [
        {
          label: "Sorszám",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a sorszámok között",
          },
        },
        {
          label: "Dátum/idő",
          field: "created_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a dátumok között",
          },
        },
        {
          label: "Esemény tárgya",
          field: "event",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Adta",
          field: "sender",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Vette",
          field: "reciever",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
      ],
      temporary_reconnect_log_columns: [
        {
          label: "Indítva",
          field: "started_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Indította",
          field: "starter",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Fesz alá helyezve",
          field: "reconnected_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Fesz alá helyezte",
          field: "reconnecter",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Indítva",
          field: "closed_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Indította",
          field: "closer",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Feszmentesítve",
          field: "isolated_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Feszmentesítette",
          field: "isolater",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
      ],
    };
  },
  mounted() {
    this.back_url = process.env.VUE_APP_BACK_URL;
  },
  created() {
    Log.messageLogs(this.$route.params.id).then((response) => {
      this.message_logs = response.data;
    });
    Log.temporaryReconnectLogs(this.$route.params.id).then((response) => {
      this.temporary_reconnect_logs = response.data;
    });
    Log.unplugLogs(this.$route.params.id).then((response) => {
      this.unplug_logs = response.data;
    });
    Log.reconnectLogs(this.$route.params.id).then((response) => {
      this.reconnect_logs = response.data;
    });
    Log.printLogs(this.$route.params.id).then((response) => {
      this.print_logs = response.data;
    });
    Isolation.show(this.$route.params.id)
      .then((response) => {
        this.$set(this, "isolation", response.data);
        Task.show(this.isolation.first_task_id)
          .then((response) => {
            this.$set(this, "task", response.data);
            if (response.data.partner_id) {
              User.getRole(6).then((response) => {
                if (response.data.length != 0) {
                  this.partner_users = response.data.filter(
                    (item) => item.partner_id == this.task.partner_id
                  );
                } else {
                  this.partner_users = response.data;
                }
              });
              Partner.show(response.data.partner_id).then((response) => {
                this.partner = response.data;
              });
            }
            if (response.data.workflow_id) {
              Workflow.show(response.data.workflow_id).then((response) => {
                this.workflow = response.data;
              });
            }
            /*if(this.user.role_id == 7){
						Task.setOperator(this.task.id,{operator_id: this.user.id});
					}*/
            //console.log([...new Set(this.task.task_permits.map(item => item.permit_type))])
          })
          .catch(() => {
            this.$set(this, "task", { name: "ismeretlen", notfound: true });
          });
      })
      .catch(() => {
        this.$set(this, "isolation", { name: "ismeretlen", notfound: true });
      });

    this.isolation_statuses = JSON.parse(
      localStorage.getItem("constants")
    ).isolation_status;
    this.task_statuses = JSON.parse(
      localStorage.getItem("constants")
    ).task_status;
    this.security_types = JSON.parse(
      localStorage.getItem("constants")
    ).security_type;
  },
};
</script>

<style></style>
